/** Default-family portrait shown when a family has no pip avatar asset. */
export const PIP_AVATAR_FALLBACK = 'assets/images/pip-avatars/magpie.png';

/** Path of the pip portrait asset for a theme family (each "bird" family ships one). */
export function pipAvatarSrcFor(family: string): string {
  return `assets/images/pip-avatars/${family}.png`;
}
